import { FC, createElement } from 'react';
import { twMerge } from 'tailwind-merge';

type TagProps = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | undefined;

interface HeadingProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  as?: TagProps;
}

const Heading: FC<HeadingProps> = props => {
  const { children, as = 'h2', className = '', style } = props;

  return createElement(
    as,
    {
      style: style,
      className: twMerge(`px-3 text-3xl font-semibold`, className),
    },
    children
  );
};

export default Heading;
